import React, { useState, useEffect } from "react";
import DataCard from "../../components/common/DataCard/DataCard";
import MeetingsTable from "./MeetingsTable";
import { useGetMeetingsSummaryByUserIdQuery } from "./meetingSlice";
import { selectCurrentUser } from "../auth/authSlice";
import { useSelector } from "react-redux";

const Meetings = () => {
  const user = useSelector(selectCurrentUser);
  const ceilTargetValue = (value) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? Math.ceil(numericValue) : 0;
  };

  const [type, setType] = useState("today");
  const [selectedUserID, setSelectedUserID] = useState(user.userID);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  function handleChildClick(value, startDate, endDate) {
    setType(value);
    setStartDate(startDate);
    setEndDate(endDate);
  }

  function handleEmployeeSelection(value) {
    setSelectedUserID(value === "all" ? user.userID : value.userId);
  }

  const {
    data: newMeetingSummary,
    isLoading: isSummaryLoading,
    isError: isSummaryError,
  } = useGetMeetingsSummaryByUserIdQuery({
    userId: selectedUserID,
    type,
    startDate: startDate || "-",
    endDate: endDate || "-",
  });

  const [individualSummaryData, setIndividualSummaryData] = useState({
    current: 0,
    target: 0,
    isMonitory: false,
  });

  const [teamSummaryData, setTeamSummaryData] = useState({
    current: 0,
    target: 0,
    isMonitory: false,
  });

  useEffect(() => {
    if (newMeetingSummary) {
      setIndividualSummaryData({
        current: newMeetingSummary.individualAchievement,
        target: ceilTargetValue(newMeetingSummary.individualTarget),
        isMonitory: false,
      });
      setTeamSummaryData({
        current: newMeetingSummary.teamAchievement,
        target: ceilTargetValue(newMeetingSummary.teamTarget),
        isMonitory: false,
      });
    }
  }, [newMeetingSummary]);

  return (
    <>
      <div className="row mb-2 mx-md-0">
        <div className="col-md-6 col-sm-12 pe-md-1 data-card-column-left">
          <DataCard data={individualSummaryData} title={"My Meetings Booked"} />
        </div>
        <div className="col-md-6 col-sm-12 ps-md-1 data-card-column-right">
          <DataCard data={teamSummaryData} title={"Team Meetings Booked"} />
        </div>
      </div>
      <div className="card content-card">
        <div className="card-body">
          <MeetingsTable
            handleFilter={handleChildClick}
            handleEmployeeSelection={handleEmployeeSelection}
          />
        </div>
      </div>
      {!isSummaryLoading && !isSummaryError && newMeetingSummary && (
        <div className="meeting-summary">
          <p>Individual Target: {ceilTargetValue(newMeetingSummary.individualTarget)}</p>
          <p>Individual Achievement: {newMeetingSummary.individualAchievement}</p>
          <p>Team Target: {ceilTargetValue(newMeetingSummary.teamTarget)}</p>
          <p>Team Achievement: {newMeetingSummary.teamAchievement}</p>
        </div>
      )}
    </>
  );
};

export default Meetings;
